var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"mb-3 pr-0",attrs:{"xl":"3","md":"4","sm":"6"}},[_c('select-button',{attrs:{"active":_vm.isActive,"icon":_vm.icon,"label":_vm.label},on:{"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }